import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { TenantIdService } from './shared/services/tenant-id.service';
import { ConfigurationService } from './shared/services/configuration.service';
import { TenantInfoSource } from './shared/interfaces/tenant.interfaces';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'define-front';
    subdomainRegex = new RegExp('^([a-z0-9\-]+)\.licence');
    private isRedirecting = false;

    constructor(
        // private activatedRoute: ActivatedRoute,
        private router: Router,
        private tenantIdService: TenantIdService,
        private configService: ConfigurationService
    ) { }

    ngOnInit(): void {
        this.router.events.subscribe((e) => {
            if (e instanceof RoutesRecognized) {
                // Extract tenant from the RoutesRecognized event directly
                const routeParams = this.extractParamsFromRoutesRecognized(e);
                
                let domain = window.location.hostname;
                let matchResult = this.subdomainRegex.exec(domain);

                let subdomainTenantName = matchResult?.[1];

                let tenantName = (routeParams['tenantId'] ?? subdomainTenantName) ?? 'definely';
                let source: TenantInfoSource = routeParams['tenantId'] 
                    ? 'path'
                    : (subdomainTenantName 
                        ? 'subdomain'
                        : 'notset');
                
                if ((source == 'notset' || tenantName == '') && !this.isRedirecting) {
                    this.isRedirecting = true;
                    this.router.navigate(['/t/' + tenantName + '/']).then(() => {
                        this.isRedirecting = false;
                    });
                    return;
                }

                if (source !== 'notset' && tenantName !== '') {
                    this.tenantIdService.setTenantId(tenantName ?? '', source);
                }
            }
            
            if (e instanceof NavigationEnd) {
                this.configService.getAppConfig()
                    .subscribe(r => {
                        // console.log(r);
                    });
            }
        });
    }

    extractParamsFromRoutesRecognized(event: RoutesRecognized): { [key: string]: string } {
        let params = {};
        
        // Walk through the route tree to find all params
        const walkRoutes = (route: any) => {
            if (route.params) {
                params = { ...params, ...route.params };
            }
            if (route.children && route.children.length > 0) {
                route.children.forEach((child: any) => walkRoutes(child));
            }
        };
        
        walkRoutes(event.state.root);
        return params;
    }

    mergeRouteParams(router: Router): { [key: string]: string } {
        let params = {};
        let route = router.routerState.snapshot.root;
        
        do {
            params = { ...params, ...route.params };
            route = route.firstChild;
        } while (route);

        return params;
    }
}
